import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="-1 -1 28 34">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#8091A5"
      d="M14.3 3C16.4.2 19.4.2 19.4.2s.4 2.5-1.7 5C15.5 7.9 13 7.4 13 7.4s-.6-2 1.3-4.4m-1.1 6.3c1.1 0 3.1-1.4 5.7-1.4 4.4 0 6.2 3.2 6.2 3.2s-3.4 1.7-3.4 5.9c0 4.8 4.3 6.5 4.3 6.5s-3.1 8.3-7.1 8.3c-1.8 0-3.3-1.3-5.3-1.3s-4 1.3-5.3 1.3c-3.6 0-8.3-8-8.3-14.3 0-6.2 4-9.6 7.7-9.6 2.4 0 4.2 1.4 5.5 1.4"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-ios.es6.js